module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p12.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "fm1"
  }, [_c('b', [_vm._v("Paula Christensen, CPRW, CJSS, CCMC Strategic Career Coaches")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_vm._v("(920) 264-0806")])]), _c('p', {
    staticClass: "txc"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "href": "http://strategiccareercoaches.com",
      "id": "AHE",
      "target": "_blank"
    }
  }, [_vm._v("strategiccareercoaches.com")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('a', {
    attrs: {
      "href": "mailto:paula@strategiccareercoaches.com",
      "id": "Ak"
    }
  }, [_vm._v("paula@strategiccareercoaches.com")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('a', {
    attrs: {
      "href": "http://www.linkedin.com/in/paulachristensen1",
      "id": "Ajf",
      "target": "_blank"
    }
  }, [_vm._v("www.linkedin.com/in/paulachristensen1")])]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("As a Certified Professional Resume Writer, Interview Coach, Career Coach, and Certified Job Search Strategist, Paula’s expertise is helping job seekers land jobs they love. What makes Paula different? She cares about their successes. Paula loved her corporate recruiting job but was sometimes frustrated because she knew with a bit of fine-tuning, new graduates could be more successful. Her main strength is connecting with people to help identify their differentiators, thereby making them more marketable. She loves her job and can’t imagine doing anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Whether you are ready for help landing that first internship or job after graduation, Paula is here to assist with resume writing, interview preparation, and developing job search strategies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Paula’s background is in Corporate Recruiting and Human Services. She is excited to help people find jobs. As a former Human Resource Pro-fessional, she knows what companies are looking for in applicants. After interviewing thousands of candidates over the course of a decade, she’s learned what makes job seekers stand out.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2d5df6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter13.vue
// module id = 102
// module chunks = 0